import { i18n } from '@fs/zion-locale'

export default {
  cameraInfo: () => i18n.t('projectDashboard.projectInfo.cameraInfo', 'Camera Info'),
  estimatedCompletion: (numberOfImages, completionDate) =>
    i18n.t(
      'projectDashboard.projectInfo.estimatedCompletion',
      'Estimated completion for {number, plural, one {# image} other {# images}}: {completionDate}',
      {
        numberOfImages,
        completionDate,
      }
    ),
  estimatedImagesActualImages: (estimatedImages, actualImagesCaptured) =>
    i18n.t(
      'projectDashboard.projectInfo.estimatedImagesActualImages',
      'Estimated Images: {estimatedImages}. Actual Images Captured: {actualImagesCaptured}.',
      { estimatedImages, actualImagesCaptured }
    ),
  language: () => i18n.t('projectDashboard.projectInfo.language', 'Language'),
  location: () => i18n.t('projectDashboard.projectInfo.location', 'Location'),
  projectIdHeader: () => i18n.t('projectDashboard.projectInfo.projectIdHeader', 'Project ID'),
}
